// extracted by mini-css-extract-plugin
export default {"occupanciesContainer":"rate_plan_occupancy_occupanciesContainer__-0Muq","occupancyCell":"rate_plan_occupancy_occupancyCell__l8bgq"};